import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/ie11"; // For IE 11 support
import "./polyfill";
import moment from "moment";
import ReactDOM from "react-dom";
import momentLocalizer from "react-widgets-moment";
import App from "./App";
import { unregister } from "./serviceWorker";
import "./index.css";
import "react-table/react-table.css";

moment.locale("en-gb");
moment.updateLocale("en", {
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4, // The week that contains Jan 4th is the first week of the year.
  },
});
momentLocalizer(moment);

ReactDOM.render(<App />, document.getElementById("root"));

// Service workers are not registered — see ./serviceWorker for the opt-in
// `register` path if offline/PWA behaviour is later required. Learn more:
// http://bit.ly/CRA-PWA
unregister();
